<template>
  <i
    class="material-icons overflow"
    :id="`overflow-trigger-${itemId}`"
    @click.stop="show_options()"
    >more_horiz</i
  >
</template>

<script>
export default {
  name: 'Overflow',
  data() {
    return {
      drop_showing: false,
    };
  },
  props: {
    options: Array,
    itemId: [String, Number],
  },
  methods: {
    show_options() {
      this.$store.dispatch('setOverflowDropShowing', false);

      const rect = document
        .querySelector(`#overflow-trigger-${this.itemId}`)
        .getBoundingClientRect();
      const scrollTop = document.querySelector('#main-view').scrollTop - 80;
      this.$store.dispatch('setOverflowDropPosition', {
        top: rect.top + scrollTop,
        left: rect.left,
      });

      this.$store.dispatch('setOverflowOptions', this.options);
      this.$store.dispatch('setOverflowItemId', this.itemId);

      setTimeout(() => {
        this.$store.dispatch('setOverflowDropShowing', true);
      }, 100);
    },
  },
};
</script>
<!--TODO - Add Scoped-->
<style lang="scss" scoped>
//@import '../styles/_styles.scss';

.overflow {
  position: relative;
}
</style>
